<div normal>
        <modal-default-mmaxapp>
                <div class="tarjetaconfirmar">
                        <div class="titulo">
                                Función no implementada
                        </div>
                        <div class="leyendaconfirmar">
                                Esta función aún no se ha implementado.
                                <br>
                                <br>
                                Por favor, inténtelo en otro momento
                                <br>
                                Por cualquier duda o reclamo, comuníquese con el proveedor. ¡Gracias!
                        </div>
                        <div class="botones">
                                <button class="buttonpc whibutton" (click)="aceptar()">Aceptar</button>
                        </div>
                </div>
        </modal-default-mmaxapp>
</div>